var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 1000 1000",
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M550.1,552.3H449.9c-6.1,0-11.1,5-11.1,11.1v100.2c0,6.1,5,11.1,11.1,11.1h100.2c6.1,0,11.1-5,11.1-11.1v-49.5c0,0,0-0.1,0-0.1v-50.6C561.3,557.3,556.3,552.3,550.1,552.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.2,210.5H689.3v-89.1C689.3,60,639.4,10,578,10H422c-61.4,0-111.4,50-111.4,111.4v89.1H76.8c-36.8,0-66.8,30-66.8,66.8V456c0,23.8,13.1,46.2,39,66.7v400.4C49,960,79,990,115.8,990h768.4c36.8,0,66.8-30,66.8-66.8V523.1c25.9-20.8,39-43.4,39-67.4V277.3C990,240.4,960,210.5,923.2,210.5z M355.2,121.4c0-36.8,30-66.8,66.8-66.8H578c36.8,0,66.8,30,66.8,66.8v89.1H355.2V121.4z M912.3,541.7c-75.1,40.8-203.3,71.3-306.5,85.6v36.4c0,30.7-25,55.7-55.7,55.7H449.9c-30.7,0-55.7-25-55.7-55.7v-37.6c-50.5-7.1-103.3-17.4-151.3-29.6c-68.6-17.4-122.8-37.1-161.1-58.7c-8-4.5-10.9-14.7-6.3-22.8c4.5-8,14.7-10.9,22.8-6.3c68.4,38.6,192.7,68.7,296,83.7v-28.9c0-30.7,25-55.7,55.7-55.7h100.2c30.7,0,55.7,25,55.7,55.7v30.1c99.1-14,220.1-43,290.5-81.2c8.1-4.4,18.3-1.4,22.7,6.7C923.4,527.2,920.4,537.3,912.3,541.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.ecd66392effb5bf5d79dcbffd236babd.svg";
export { ForwardRef as ReactComponent };